import { RootState } from "../..";

export const configSelector = (state: RootState) => state.config;
